
var $chartHolder;
var chartHeight = 270;
var chartWidth = 250;
var chartIndex = 0;
var chartObjs = [];
var $charts = null;
var charts = [];
var bSlideActive = false;

function initGradebook(element) {
  //clear chart objects
  chartObjs = [];
  charts = [];

  $chartHolder = $('.svg-chart-holder', element);

  $charts = $('.percent-graphic', element);

  if( $charts.length == 0 )
    return;
  else
    $chartHolder.empty();
  /* */
  $charts.each( function() {
    var obj = {
      text: $(this).find('h4').text(),
      totalPercentage: parseFloat($(this).find('.number').text()),
      color: $(this).find('.number').attr('class')
    };
    chartObjs.push( obj );
  }).hide();

  $chartHolder.show();
  buildCharts();

  // RESIZE EVENT
  $(window).on('resize', function() {
    updateChartHolder();
  }).trigger('resize');

}

function updateChartHolder() {
  var i;
  var containerW = $chartHolder.width();
  var pos = getXPosition( charts.length, containerW );

  var newWidth = Math.floor( containerW / 2 );
  var newHeight = newWidth * (chartHeight/chartWidth);

  for( i= -1; ++i < charts.length; ) {
    var cWidth = newWidth + 'px';
    var cLeft = pos[i] + 'px';
    charts[i].style({'left': pos[i] + 'px', 'width': newWidth + 'px', 'height': newWidth + 'px' });
  }
  $chartHolder.height( newHeight );

  $('.arrow').each( function() {
    $(this).height(newHeight);
    $(this).find('span').css('top',((newHeight-36)/2) + 'px');
  });
}

function getXPosition( $numItems, $containerWidth ) {
  var newWidth = Math.floor( $containerWidth / 2 );
  if( $numItems == 1 )
    return [ ($containerWidth-newWidth) / 2 ];
  if( $numItems == 2 )
    return [ 0, newWidth ];
  if( $numItems == 3 )
    return [ -(newWidth/2), ($containerWidth-newWidth) / 2, $containerWidth-(newWidth/2)];
}

function buildCharts() {
  var i;
  var range = Math.min( chartObjs.length, 2 );
  $('svg-chart-holder').empty();
  for( i = -1; ++i < range; ) {
    charts.push( new GradeChart( '.svg-chart-holder', chartObjs[i], true ) );
  }

  if( chartObjs.length > 2 ) {
    console.log(chartObjs);
    charts.unshift( new GradeChart( '.svg-chart-holder', chartObjs[chartObjs.length-1], true ) );

    var leftArrow = $('<a class=\'arrow arrow-left\' href=\'javascript:;\' aria-label=\'previous chart\'><span class=\'glyphicon glyphicon-chevron-left\'></a>');
    $chartHolder.append(leftArrow);
    leftArrow.on('click', previousChart );

    var rightArrow = $('<a class=\'arrow arrow-right\' href=\'javascript:;\' aria-label=\'next chart\'><span class=\'glyphicon glyphicon-chevron-right\'></a>');
    $chartHolder.append(rightArrow);
    rightArrow.on('click', nextChart);
  }
}

function nextChart() {
  if( bSlideActive )
    return;

  var onMoveComplete = function() {
    var removedItem = charts.shift();
    removedItem.remove();
    bSlideActive = false;
  };

  chartIndex = validateIndexRange( ++chartIndex, chartObjs.length );
  var nextItem = validateIndexRange( chartIndex+1, chartObjs.length );
  var containerW = $chartHolder.width();
  var itemWidth = Math.floor( containerW / 2 );

  charts.push( new GradeChart( '.svg-chart-holder', chartObjs[nextItem] )
    .style( {
      'left': (containerW + (itemWidth * 0.5)) + 'px',
      'width': itemWidth + 'px',
      'height': itemWidth + 'px'
    }) );

  bSlideActive = true;

  var farLeft = -itemWidth * 1.5;

  TweenLite.to( charts[0], 0.5, { css:{ left: farLeft + (itemWidth*0) }, onComplete: onMoveComplete } );
  TweenLite.to( charts[1], 0.5, { css:{ left: farLeft + (itemWidth*1) } } );
  TweenLite.to( charts[2], 0.5, { css:{ left: farLeft + (itemWidth*2) } } );
  TweenLite.to( charts[3], 0.5, { css:{ left: farLeft + (itemWidth*3) } } );
}

function previousChart() {
  if( bSlideActive )
    return;

  var onMoveComplete = function() {
    var removedItem = charts.pop();
    removedItem.remove();
    bSlideActive = false;
  };

  chartIndex = validateIndexRange( --chartIndex, chartObjs.length );
  var nextItem = validateIndexRange( chartIndex-1, chartObjs.length );
  var containerW = $chartHolder.width();
  var itemWidth = Math.floor( containerW / 2 );

  charts.unshift( new GradeChart( '.svg-chart-holder', chartObjs[nextItem] ).style( {
    'left': (-itemWidth * 1.5) + 'px',
    'width': itemWidth + 'px',
    'height': itemWidth + 'px'
  }) );

  bSlideActive = true;

  TweenLite.to( charts[0], 0.5, { css:{ left: -itemWidth / 2 }, onComplete: onMoveComplete } );
  TweenLite.to( charts[1], 0.5, { css:{ left: (containerW - itemWidth)/2 } } );
  TweenLite.to( charts[2], 0.5, { css:{ left: containerW - (itemWidth/2) } } );
  TweenLite.to( charts[3], 0.5, { css:{ left: containerW + (itemWidth*1.5) } } );
}


function validateIndexRange( $index, $numItems ) {
  if( $index < 0 )
    return $numItems + $index;
  else if ( $index >= $numItems )
    return $numItems - $index;
  else
    return $index;
}

function GradeChart( $parent, $obj, $bAnimate ) {
  var w = chartWidth;
  var h = chartHeight;
  var r = (w * 0.5);
  var p = Math.PI * 2;

  $obj.percentage = 0;

  var arc = d3.svg.arc().innerRadius( r * 0.7 ).outerRadius( r * 0.8 ).startAngle( 0 );
  var chart = d3.select($parent).append('svg')
    .attr('class', 'svg-chart')
    .attr('viewBox', '0 0 ' + w + ' ' + h )
    .attr('preserveAspectRatio', 'xMidYMid meet');

  var meter = chart.append('g')
    .attr('transform', 'translate(' + w / 2 + ',' + h / 2 + ')')
    .attr('class', 'gradeChart');

  var outerCircle = meter.append('circle')
    .attr( 'r', r*.8 )
    .attr( 'fill', '#ebebeb')
    .attr('transform','translate(0,15)');

  var innerCircle = meter.append('circle')
    .attr( 'r', r*.7 )
    .attr( 'fill', '#fff')
    .attr('transform','translate(0,15)');

  var arcPath = meter.append('path')
    .attr('class', 'arc')
    .attr('class', $obj.color )
    .attr('d', arc.endAngle( p * ( $obj.percentage/100) ))
    .attr('transform','translate(0,15)');

  var percentageText = meter.append('text')
    .attr('text-anchor', 'middle')
    .attr('dy', '.7em')
    .attr('class', 'gradeChart-number' + ' ' + $obj.color )
    .text( $obj.percentage+'%' );

  var titleText = meter.append('text')
    .attr('text-anchor', 'middle')
    .attr('class', 'gradeChart-title')
    .attr('dy', -110)
    .text($obj.text);


  var onTweenProgress = function() {
    var percent = Math.round( $obj.percentage );
    percentageText.text( percent+'%' );
    arcPath.attr('d', arc.endAngle( p * ( $obj.percentage/100) ));
  };

  var onTweenComplete = function() {
    percentageText.text( $obj.percentage+'%' );
    arcPath.attr('d', arc.endAngle( p * ( $obj.percentage/100) ));
  };

  var $animSpeed = 0;
  var $animDelay = 0;
  if( $bAnimate ) {
    $animSpeed = 2.0;
    $animDelay = 1.5;
  }

  TweenLite.to( $obj, $animSpeed, { percentage: $obj.totalPercentage, delay: $animDelay, onComplete: onTweenComplete, onUpdate: onTweenProgress } );
  return chart;
}

export default {
  init: function(element) {
    initGradebook(element);
  }
};

